import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Modal Trigger",
  type: "rh/components/content/modaltrigger",
  isContainer: true,
  config: {
    emptyLabel: "Modal Trigger",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
